import type { Feature } from './Feature';

export function getLocalOverride(featureName: Feature): boolean | null {
  const localValue = window.localStorage.getItem(`HJ_OVERRIDE_FEATURE:${featureName}`);

  if (localValue === '1' || localValue === 'true') {
    return true;
  }

  if (localValue === '0' || localValue === 'false') {
    return false;
  }

  return null;
}
